export default __webpack_public_path__ + "static/media/alhamdulillahCalligraphy.43759d2e.png";